export const buttons = [
    { path: '/Admin/EmployeesResendAccountInvite', name: 'Resend Account Invite' },
    { path: '/Admin/EmployeesBlockDays', name: 'Block Days' },
    { path: '/Admin/SendNotificationDashboard', name: 'Send Notification' },
  ];